<template>
  <base-modal
    hideFooter
    :size="'lg'"
    @hidden="onCloseModal"
    @show="onModalOpen"
    :modalId="'manage-stock'"
  >
    <template #modal-header>
      <div class="head-label"><b>Transfer : </b>{{ formReward.name }}</div>
    </template>
    <div class="w-100 px-2">
      <b-row class="pl-4 pr-2 pb-2">
        <b-col cols="12" lg="8" sm="12">
          <b-row>
            <b-col cols="12" lg="6" sm="12">
              <b-row>
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Reference'"
                    label-for="reference"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="reference"
                      required
                      disabled
                      v-model="formReward.reference"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-row class="justify-content-end">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Privilege Type'"
                    label-for="reward-type"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="reward-type"
                      required
                      disabled
                      v-model="formReward.privilegeType"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12" v-if="formReward.couponTypeVal != 0">
              <b-row class="">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Coupon Type'"
                    label-for="coupon-type"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="coupon-type"
                      required
                      disabled
                      v-model="formReward.couponType"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-row :class="(formReward.couponTypeVal != 0) && 'justify-content-end'">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Removal Strategy'"
                    label-for="removal-strategy"
                    label-class="font-medium-5"
                  >
                    <v-select
                      v-model="formManageStock.removalStrategy"
                      class="select-format-container font-medium-5 bg-dropdown"
                      :class="[
                        formManageStock.removalStrategy
                          ? 'select-format-selected'
                          : null,
                        {},
                      ]"
                      :reduce="(option) => option.value"
                      :options="removalOptions"
                      required
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="12" sm="12">
              <b-row class="mt-2">
                <b-col cols="12" lg="12" sm="12">
                  <span class="font-medium-5">{{
                    `Transfer ( Balance: ${qtyTotal} )`
                  }}</span>
                  <b-row class="mb-2">
                    <b-col cols="12" lg="3" sm="4">
                      <span class="font-medium-5">Transfer Quantity</span>
                    </b-col>
                    <b-col cols="12" lg="3" sm="4">
                      <input-spin
                        :mode="'add'"
                        :numValue="quantityValue.add"
                        @update-number="updateAddQuantity"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="'Note'"
                label-for="note"
                label-class="font-medium-5"
              >
                <b-form-textarea
                  id="note"
                  rows="3"
                  required
                  v-model="formReward.note"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="4" sm="12">
          <img-zoom-content
            :width="'100%'"
            :height="'175px'"
            :imageUrl="formReward.image"
          />
        </b-col>
      </b-row>
      <div class="mt-2 mb-2">
        <div class="d-flex justify-content-center">
          <cancel-button class="mr-1" @click.native="onCloseModal" />
            <save-button
            @click.native="onSubmitTransfer"
            :loading="loading.form"
            class="ml-1"
          />
        </div>
      </div>
    </div>

    <b-row class="modal-body-container mb-1"> </b-row>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import useTransferStockForm from "../hooks/useTransferStockForm";
import ImgZoomContent from "../../inventory-privilege-history/components/ImgZoomContent.vue";
import InputSpin from "@/views/components/input-spin/InputSpin.vue";
export default {
  components: { BaseModal, ImgZoomContent, InputSpin },
  props: {
    rewardDetail: { type: Object, default: {} },
  },
  setup(props) {
    const {
      formReward,
      formManageStock,
      quantityValue,
      removalOptions,
      qtyTotal,
      loading,
      onModalOpen,
      updateAddQuantity,
      onSubmitTransfer,
      onCloseModal,
    } = useTransferStockForm(props);
    return {
      formReward,
      formManageStock,
      quantityValue,
      removalOptions,
      qtyTotal,
      loading,
      onModalOpen,
      updateAddQuantity,
      onSubmitTransfer,
      onCloseModal,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/inventory/manage-stock.css";
@import "~@/assets/css/override-styles/radio.css";
</style>
